module.exports = __webpack_public_path__ + "static/img/Robbie_Gray_mobile.ddf2c89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Robbie_Gray_mobile.jpg
// module id = El0W
// module chunks = 0